export enum NotificationType {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
}
